module.exports = __webpack_public_path__ + "static/media/ferrari-go-drive.a6759bb9.jpg";